module.exports = __webpack_public_path__ + "static/media/promo-tag-close.f5181f8e.svg";